<template>
  <div>
    <section class="bg-white py-5" aria-label="Location details">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="12" md="12" lg="8">
            <h1 class="location-title mb-3">{{ location.name }}</h1>
            <debug-bar :api-response="location"></debug-bar>
            <list-info
              v-if="location.service_taxonomys"
              :list-array="location.service_taxonomys"
              value-name="name"
              id-name="id"
              parent-name="taxonomy"
            ></list-info>
            <list-info
              v-if="location.service_areas"
              :list-array="location.service_areas"
              value-name="service_area"
              id-name="id"
            ></list-info>
            <basic-info :data-item="location"></basic-info>
            <b-card-text v-html="location.description"> </b-card-text>
            <span
              v-if="
                location.accessibility_for_disabilities &&
                location.accessibility_for_disabilities[0].accessibility != 'false' &&
                location.accessibility_for_disabilities[0].accessibility.length > 1
              "
            >
              Accessibility:
              <ul>
                <li
                  v-for="(access, index) in location.accessibility_for_disabilities"
                  :key="index"
                  class="accessibility"
                >
                  {{ access.accessibility.replace(/-/gi, ' ') }}
                </li>
              </ul>
            </span>
          </b-col>
        </b-row>
        <b-row v-if="location.service_at_locations && location.service_at_locations.length > 0">
          <b-col
            v-if="location.service_at_locations[0]"
            sm="12"
            class="single-location-map bg-light mb-4 mt-2"
          >
            <map-buttons :serv="locationServices">></map-buttons>
            <map-component :serv="locationServices" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h3>Services at this location:</h3>
          </b-col>
          <service-list v-for="service in locationServices" :key="service.id" :service="service">
          </service-list>
        </b-row>
        <b-skeleton-wrapper v-if="loading == true">
          <b-skeleton height="2.4rem" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
          <b-skeleton height="10rem" animation="wave" width="70%"></b-skeleton>
        </b-skeleton-wrapper>
      </b-container>
    </section>
  </div>
</template>

<script>
import store from '@/store/'
import { mapGetters } from 'vuex'
import { FETCH_LOCATION } from '@/store/actions.type.js'
import DebugBar from '@/components/DebugBar'
import ListInfo from '@/components/elements/ListInfo'
import MapComponent from '@/components/map/MapComponent'
//import ServiceTimes from '@/components/elements/ServiceTimes'
//import LocationInfo from '@/components/elements/LocationInfo'
import BasicInfo from '@/components/elements/BasicInfo'
import ServiceList from '@/components/list/ServiceList'
import BackButton from '@/components/elements/BackButton'
import MapButtons from '../map/MapButtons.vue'

export default {
  name: 'Service',
  components: {
    DebugBar,
    ListInfo,
    ServiceList,
    MapComponent,
    BasicInfo,
    BackButton,
    MapButtons,
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    locationServices() {
      if (this.location.service_at_locations) {
        let servs = this.location.service_at_locations.map((loc) => {
          return loc.service
        })
        console.log(servs)
        return servs
      }
      return []
    },
    ...mapGetters(['location']),
  },
  mounted() {
    store.dispatch(FETCH_LOCATION, this.$router.history.current.params.id).then(() => {
      this.loading = false
    })
  },
}
</script>
<style>
.accessibility {
  text-transform: capitalize;
}
</style>